import { graphql } from "gatsby";
import clsx from "clsx";
import PropTypes from "prop-types";
import React, { ReactElement } from "react";
import Helmet from "react-helmet";
import { Container, Typography } from "@material-ui/core";
import { createStyles, makeStyles } from "@material-ui/core/styles";

import Layout from "../components/Layout";
import Member from "../components/Member";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      display: "grid",
    },
    header: {
      [theme.breakpoints.down("sm")]: {
        marginTop: theme.spacing(4)
      },
      [theme.breakpoints.up("sm")]: {
        marginTop: theme.spacing(8)
      },
      marginBottom: theme.spacing(8)
    },
    heading: {
      fontSize: "16pt",
      fontWeight: "bold"
    },
    subheading: {
      fontSize: "14pt",
      fontWeight: "bold"
    },
    members: {},
    description: {}
  })
);

export const TeamPageTemplate = ({
  description,
  members
}): ReactElement => {
  const classes = useStyles();

  return (
    <section className={classes.root}>
      <Container className={clsx(classes.header)} component="header" fixed>
        {description && (
          <Typography className={clsx(classes.description)} component="p">
            {description}
          </Typography>
        )}
      </Container>
      <Container className={clsx(classes.members)} component="div" fixed>
        {members?.map((member, index) => (
          <Member
            key={index}
            member={member}
            orientation={index % 2 === 0 ? "ltr" : "rtl"}
          />
        ))}
      </Container>
    </section>
  );
};

TeamPageTemplate.propTypes = {
  featuredimage: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
  imagewidth: PropTypes.string,
  description: PropTypes.string,
  members: PropTypes.array
};
